// SyncService.js
import {
  collection,
  getDocs,
  doc,
  setDoc,
  deleteDoc,
} from "firebase/firestore";

import {
  ref as storageRef,
  getDownloadURL,
  uploadBytes,
  deleteObject,
} from "firebase/storage";
import { db, storage } from "../firebase";

const CATEGORY_TO_INDEX = {
  "Leadership and Governance": "0",
  "Quality Assurance": "1",
  Research: "2",
  "Teaching and Learning": "3",
  "Student Services": "4",
  "External Relations": "5",
  "Resource Management": "6",
  "Multi-Page Documents": "7",
};

export async function syncCategoryFiles(userId, selectedFolder) {
  if (!userId || !selectedFolder?.folderId) {
    throw new Error("Missing user or folder information.");
  }
  const folderId = selectedFolder.folderId;
  const baseWritePath = ["users", userId, "folders", folderId, "subfolders"];

  // move in Storage: download → upload → delete
  async function moveStorage(oldPath, newPath, count) {
    const oldRef = storageRef(storage, oldPath);
    const url = await getDownloadURL(oldRef);
    const blob = await (await fetch(url)).blob();
    const newRef = storageRef(storage, newPath);
    await uploadBytes(newRef, blob);
    await deleteObject(oldRef);
    console.log("Moving count: " + count + " to storage... [SUCCESS]");
  }

  async function processSection(sectionName) {
    const snap = await getDocs(
      collection(
        db,
        "users",
        userId,
        "folders",
        folderId,
        "accreditation_folder",
        "main",
        sectionName
      )
    );

    let count = 0;
    for (const docSnap of snap.docs) {
      const data = docSnap.data();
      const category = data.classificationCategory;
      const idx = CATEGORY_TO_INDEX[category];
      if (idx == null) continue;

      const oldPath = data.storagePath; // your existing path
      const fileName = oldPath.split("/").pop(); // last segment
      const newPath = `users/${userId}/folders/${folderId}/${category}/${fileName}`;

      try {
        // 1) move the blob in Storage
        await moveStorage(oldPath, newPath, count);

        // 2) write new metadata under subfolders/{idx}/files
        const fileDoc = doc(db, ...baseWritePath, idx, "files", docSnap.id);
        await setDoc(
          fileDoc,
          {
            ...data,
            subfolderName: category,
            storagePath: newPath,
            source: sectionName,
            fileId: docSnap.id,
          },
          { merge: true }
        );

        count++;
        // 3) remove the old metadata doc
        await deleteDoc(docSnap.ref);
      } catch (err) {
        console.error("Sync error for", docSnap.id, err);
      }
    }
  }

  // run for both single_page & multi_page
  await processSection("single_page");
  await processSection("multi_page");
}
